/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable object-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useForm } from "@mantine/form";
import { Select, Collapse, Tooltip } from "@mantine/core";
import {
    IconBuilding,
    IconBuildingSkyscraper,
    IconHash,
    IconIdBadge2,
    IconReceipt2,
    IconUser,
    IconBriefcase,
    IconStack2,
    IconMapPin,
    IconRotate,
    IconChevronDown,
    IconSearch,
    IconBuildingStore,
    IconUserCircle,
    IconListCheck,
    IconShieldCheck,
    IconFlag,
    IconPercentage,
    IconLoader2,
    IconCalendar,
    IconMail,
    IconPhone,
    IconHistory,
    IconUsers,
    IconBuildingBank,
} from "@tabler/icons-react";
import { toast } from "react-toastify";
import { getData, postData } from "../../services/fetch-service";
import { updateTable, setLastSearchCriteria, clearLastSearchCriteria } from "../../redux/TableSearch/dataSlice";
import getLabels from "./newBlocks/arbk/labels";
import CountryFlag from "./newBlocks/arbk/CountryFlag";

const TURNSTILE_SCRIPT_URL = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
const isTurnstileDisabled = process.env.REACT_APP_DISABLE_TURNSTILE === "true";
const isTurnstileEnabled = !isTurnstileDisabled && Boolean((process.env.REACT_APP_TURNSTILE_SITE_KEY || "").trim());

const SEARCH_FORM_INITIAL_VALUES = {
    emriBiznesit: "",
    nui: "",
    komunaBiznesitId: "",
    sektoriId: "",
    aktivitetiKryesorId: "",
    numriPersonal: "",
    emriPronarit: "",
    mbiemriPronarit: "",
    nrFiscal: "",
    aktivitetetTjeraId: "",
    llojiBiznesitId: "",
    statusiBiznesitId: "",
    numriNjesise: "",
    numriNjesiveRegjistruar: "",
    numriPuntoreve: "",
    pronesia: "",
    shtetiIdPronarit: "",
    komunaIdPronarit: "",
    kodiInstitucionit: "",
    perqindjaPronaritHuaj: "",
    emriVjeter: "",
    email: "",
    telefoni: "",
    adresa: "",
    vitiThemelimit: "",
    vitiShuarjes: "",
    vitiNdryshimit: "",
    ndryshimiTipitId: "",
};

const ADVANCED_VALUE_KEYS = [
    "aktivitetiKryesorId",
    "numriPersonal",
    "emriPronarit",
    "mbiemriPronarit",
    "nrFiscal",
    "aktivitetetTjeraId",
    "llojiBiznesitId",
    "numriNjesise",
    "numriNjesiveRegjistruar",
    "numriPuntoreve",
    "pronesia",
    "shtetiIdPronarit",
    "komunaIdPronarit",
    "kodiInstitucionit",
    "perqindjaPronaritHuaj",
    "emriVjeter",
    "email",
    "telefoni",
    "adresa",
    "vitiThemelimit",
    "vitiShuarjes",
    "vitiNdryshimit",
    "ndryshimiTipitId",
];

function hasFilterValue(value) {
    return value !== "" && value !== null && value !== undefined;
}

function normalizeSearchFormValues(values = {}) {
    const normalized = {};
    Object.keys(SEARCH_FORM_INITIAL_VALUES).forEach((key) => {
        normalized[key] = values[key] || "";
    });
    return normalized;
}

function mapOpsionet(list) {
    const seen = new Set();
    return (Array.isArray(list) ? list : [])
        .map((item) => ({
            value: String(item.ID ?? item.LlojiBiznesitID ?? ""),
            label: item.Pershkrimi || "",
        }))
        .filter((item) => item.value !== "" && item.value !== "0")
        .filter((item) => {
            if (seen.has(item.value)) return false;
            seen.add(item.value);
            return true;
        });
}

const INPUT_CLASSES =
    "tw-w-full tw-h-9 tw-pl-10 tw-box-border tw-rounded-brand tw-border tw-border-solid tw-bg-paper tw-text-base tw-text-ink tw-font-inter tw-placeholder-muted hover:tw-bg-fieldhover focus:tw-outline-none focus:tw-shadow-focusring tw-transition-colors";
const inputBorderClasses = (error) =>
    error ? "tw-border-st-closed focus:tw-border-st-closed" : "tw-border-line focus:tw-border-navy";
const LABEL_CLASSES = "tw-block tw-mb-1 tw-text-sm tw-font-semibold tw-text-ink tw-font-inter tw-leading-snug";
const FIELD_ICON_CLASSES =
    "tw-absolute tw-left-3 tw-inset-y-0 tw-text-muted tw-pointer-events-none tw-flex tw-items-center";

const CountryItem = React.forwardRef(({ label, code, ...others }, ref) => (
    <div ref={ref} {...others}>
        <span className="tw-inline-flex tw-items-center tw-gap-2">
            <CountryFlag code={code} size={16} />
            {label}
        </span>
    </div>
));

function FieldLabel({ htmlFor, text }) {
    if (!text) return null;
    return (
        <label htmlFor={htmlFor} className={LABEL_CLASSES}>
            {text}
        </label>
    );
}

function FieldError({ children }) {
    if (!children) return null;
    return (
        <p role="alert" className="tw-m-0 tw-mt-1 tw-text-xs tw-font-medium tw-text-st-closed">
            {children}
        </p>
    );
}

function FieldTooltip({ text, children }) {
    if (!text) return children;
    return (
        <Tooltip
            label={text}
            multiline
            withArrow
            position="top"
            openDelay={120}
            events={{ hover: true, focus: true, touch: true }}
            transitionProps={{ transition: "pop", duration: 150 }}
            styles={{
                tooltip: {
                    maxWidth: 280,
                    whiteSpace: "normal",
                    lineHeight: 1.4,
                    fontSize: 13,
                    fontWeight: 600,
                    padding: "6px 10px",
                    backgroundColor: "#0E3A5E",
                    color: "#FFFFFF",
                    borderRadius: 8,
                    boxShadow: "0 6px 18px rgba(14, 58, 94, 0.22)",
                },
                arrow: { backgroundColor: "#0E3A5E" },
            }}
        >
            {children}
        </Tooltip>
    );
}

function TextField({ id, label, icon: Icon, placeholder, inputProps, numeric }) {
    const { error, onChange, ...nativeProps } = inputProps;
    const handleChange = numeric
        ? (e) => {
              e.currentTarget.value = (e.currentTarget.value || "").replace(/\D/g, "");
              onChange(e);
          }
        : onChange;
    return (
        <FieldTooltip text={!label ? placeholder : undefined}>
            <div>
                <FieldLabel htmlFor={id} text={label} />
                <div className="tw-relative">
                    <span className={FIELD_ICON_CLASSES} aria-hidden>
                        <Icon size={18} stroke={2} />
                    </span>
                    <input
                        id={id}
                        type="text"
                        inputMode={numeric ? "numeric" : undefined}
                        placeholder={placeholder}
                        className={`${INPUT_CLASSES} ${inputBorderClasses(error)} tw-pr-3`}
                        aria-label={label || placeholder}
                        aria-invalid={error ? true : undefined}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        {...nativeProps}
                        onChange={handleChange}
                    />
                </div>
                <FieldError>{error}</FieldError>
            </div>
        </FieldTooltip>
    );
}

function SelectField({
    id,
    label,
    icon: Icon,
    placeholder,
    data,
    value,
    onChange,
    searchable,
    required,
    error,
    itemComponent,
}) {
    return (
        <FieldTooltip text={!label ? placeholder : undefined}>
            <div>
                <FieldLabel htmlFor={id} text={label ? (required ? `${label} *` : label) : undefined} />
                <Select
                    id={id}
                    placeholder={placeholder}
                    itemComponent={itemComponent}
                    searchable={searchable}
                    autoComplete="off"
                    clearable
                    allowDeselect
                    icon={<Icon size={18} stroke={2} />}
                    rightSection={value ? "" : <IconChevronDown size={16} stroke={2} />}
                    rightSectionWidth={30}
                    value={value || null}
                    onChange={(next) => onChange(next || "")}
                    data={data}
                    aria-label={label || placeholder}
                    aria-required={required}
                    aria-invalid={error ? true : undefined}
                    classNames={{
                        input: `${INPUT_CLASSES} ${inputBorderClasses(error)}`,
                        icon: "tw-text-muted",
                    }}
                    styles={{
                        rightSection: { pointerEvents: "none", color: "#5A6A7A" },
                        item: { fontSize: 16, fontFamily: "Inter, Roboto, sans-serif" },
                        dropdown: { borderRadius: 10, borderColor: "#E2E8F0" },
                    }}
                />
                <FieldError>{error}</FieldError>
            </div>
        </FieldTooltip>
    );
}

function SearchSlide(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const url = useLocation();
    const { location, locale } = props;
    const L = getLabels(locale);
    const lastSearchCriteria = useSelector((state) => state.tableSearch.lastSearchCriteria);
    const [aktivitetet, setAktivitetet] = useState([]);
    const [sektoret, setSektoret] = useState([]);
    const [ndryshimetTipit, setNdryshimetTipit] = useState([]);
    const [shtetet, setShtetet] = useState([]);
    const [komunat, setKomunat] = useState([]);
    const [llojetBiznesit, setLlojetBiznesit] = useState([]);
    const [statusetBiznesit, setStatusetBiznesit] = useState([]);
    const [pronesiaOptions, setPronesiaOptions] = useState([]);
    const [perqindjaOptions, setPerqindjaOptions] = useState([]);
    const [njesiteOptions, setNjesiteOptions] = useState([]);
    const [institucionet, setInstitucionet] = useState([]);
    const [madhesiaOptions, setMadhesiaOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [advancedOpen, setAdvancedOpen] = useState(false);
    const turnstileContainerRef = useRef(null);
    const turnstileWidgetIdRef = useRef(null);
    const pendingSubmitRef = useRef(null);
    const isSubmittingRef = useRef(false);
    const lastSubmitAtRef = useRef(0);
    const localeRef = useRef(locale);
    const lastTurnstileErrorAlertRef = useRef(0);
    const previousPathRef = useRef(url.pathname);
    const languageId = locale === "sq" ? "1" : locale === "en" ? "2" : "3";

    const SEARCH_DEBOUNCE_MS = 500;

    function resetSearchLoading() {
        isSubmittingRef.current = false;
        setIsLoading(false);
        if (window.turnstile && turnstileWidgetIdRef.current !== null) {
            try {
                window.turnstile.reset(turnstileWidgetIdRef.current);
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
    }

    function resetSearchLoadingStateOnly() {
        isSubmittingRef.current = false;
        setIsLoading(false);
    }

    useEffect(() => {
        getData(`Services/GetListaAktivitetet?Gjuha=${locale}`).then((response) => {
            setAktivitetet(response.data);
        });
    }, [locale]);

    useEffect(() => {
        getData(`Services/GetSektori?Gjuha=${locale}`)
            .then((response) => setSektoret(response.data || []))
            .catch(() => setSektoret([]));
    }, [locale]);

    useEffect(() => {
        getData(`Services/ListaNdryshimitTipit?Gjuha=${locale}`)
            .then((response) => setNdryshimetTipit(response.data || []))
            .catch(() => setNdryshimetTipit([]));
    }, [locale]);

    useEffect(() => {
        getData(`Services/LlojetEBiznesit?Gjuha=${locale}`)
            .then((response) => setLlojetBiznesit(response.data || []))
            .catch(() => setLlojetBiznesit([]));

        getData(`Services/GetStatusiBiznesit?Gjuha=${locale}`)
            .then((response) => setStatusetBiznesit(response.data || []))
            .catch(() => setStatusetBiznesit([]));

        getData(`Services/GetPronesia?Gjuha=${locale}`)
            .then((response) => setPronesiaOptions(response.data || []))
            .catch(() => setPronesiaOptions([]));

        getData(`Services/GetPerqindjaPronariHuaj?Gjuha=${locale}`)
            .then((response) => setPerqindjaOptions(response.data || []))
            .catch(() => setPerqindjaOptions([]));

        getData(`Services/GetNumriNjesiveRegjistruar?Gjuha=${locale}`)
            .then((response) => setNjesiteOptions(response.data || []))
            .catch(() => setNjesiteOptions([]));

        getData(`Services/GetMadhesiaBiznesit?Gjuha=${locale}`)
            .then((response) => setMadhesiaOptions(response.data || []))
            .catch(() => setMadhesiaOptions([]));

        getData(`Services/ListaInstitucioneve?Gjuha=${locale}`)
            .then((response) => setInstitucionet(response.data || []))
            .catch(() => setInstitucionet([]));
    }, [locale]);

    useEffect(() => {
        getData(`Services/ListaShteteve?GjuhaID=${languageId}`)
            .then((response) => {
                setShtetet(response.data || []);
            })
            .catch(() => {
                getData(`Services/ListaShteteve?Gjuha=${locale}`).then((response) => {
                    setShtetet(response.data || []);
                });
            });

        getData(`Services/ListaKomunave?GjuhaID=${languageId}`)
            .then((response) => {
                setKomunat(response.data || []);
            })
            .catch(() => {
                getData(`Services/ListaKomunave?Gjuha=${locale}`).then((response) => {
                    setKomunat(response.data || []);
                });
            });
    }, [locale, languageId]);

    const aktivitetetSelect = useMemo(
        () =>
            aktivitetet.map((item) => ({
                value: String(item.NaceID || ""),
                label: item.Pershkrimi || "",
            })),
        [aktivitetet]
    );

    const sektoretSelect = useMemo(
        () =>
            (Array.isArray(sektoret) ? sektoret : [])
                .map((item) => ({
                    value: String(item.Id ?? item.id ?? ""),
                    label: item.Pershkrimi || item.pershkrimi || "",
                }))
                .filter((item) => item.value !== ""),
        [sektoret]
    );

    const ndryshimetTipitSelect = useMemo(
        () =>
            (Array.isArray(ndryshimetTipit) ? ndryshimetTipit : [])
                .map((item) => ({
                    value: String(item.ID ?? item.id ?? ""),
                    label: item.Tipi || item.tipi || "",
                }))
                .filter((item) => item.value !== ""),
        [ndryshimetTipit]
    );

    const shtetetSelect = useMemo(
        () =>
            shtetet.map((item) => ({
                value: String(item.id || item.ID || item.ShtetiID || ""),
                label: item.pershkrimi || item.Pershkrimi || item.emri || "",
                code: item.code || item.Code || "",
            })),
        [shtetet]
    );

    const komunatSelect = useMemo(
        () =>
            komunat.map((item) => ({
                value: String(item.id || item.ID || item.KomunaID || ""),
                label: item.pershkrimi || item.Pershkrimi || item.emri || "",
            })),
        [komunat]
    );

    const institucionetSelect = useMemo(
        () =>
            (Array.isArray(institucionet) ? institucionet : [])
                .map((item) => ({
                    value: String(item.Kodi ?? item.kodi ?? ""),
                    label: item.Institucioni || item.institucioni || "",
                }))
                .filter((item) => item.value !== "" && item.label !== ""),
        [institucionet]
    );

    const yearOptions = useMemo(() => {
        const current = new Date().getFullYear();
        const years = [];
        for (let y = current; y >= 1990; y -= 1) years.push({ value: String(y), label: String(y) });
        return years;
    }, []);

    const businessFormSelect = useMemo(() => mapOpsionet(llojetBiznesit), [llojetBiznesit]);
    const businessStatusSelect = useMemo(() => mapOpsionet(statusetBiznesit), [statusetBiznesit]);
    const ownershipSelect = useMemo(() => mapOpsionet(pronesiaOptions), [pronesiaOptions]);
    const unitCountSelect = useMemo(() => mapOpsionet(njesiteOptions), [njesiteOptions]);
    const puntoretSelect = useMemo(() => mapOpsionet(madhesiaOptions), [madhesiaOptions]);
    const foreignPctSelect = useMemo(() => mapOpsionet(perqindjaOptions), [perqindjaOptions]);

    const form = useForm({
        initialValues: { ...SEARCH_FORM_INITIAL_VALUES },
        validate: (values) => {
            if (Object.values(values).some(hasFilterValue)) return {};
            const message = getLabels(localeRef.current).form.validationError;
            return {
                emriBiznesit: message,
                nui: message,
                komunaBiznesitId: message,
                sektoriId: message,
                statusiBiznesitId: message,
            };
        },
    });

    useEffect(() => {
        const isSearchRoute = url.pathname === "/TableSearch" || url.pathname.startsWith("/TableDetails");
        if (isSearchRoute && lastSearchCriteria?.values) {
            const restoredValues = normalizeSearchFormValues(lastSearchCriteria.values);
            form.setValues(restoredValues);
            if (ADVANCED_VALUE_KEYS.some((key) => hasFilterValue(restoredValues[key]))) {
                setAdvancedOpen(true);
            }
        }
    }, [url.pathname, lastSearchCriteria]);

    useEffect(() => {
        const currentPath = url.pathname;
        const isSearchRoute = currentPath === "/TableSearch" || currentPath.startsWith("/TableDetails");
        const previousPath = previousPathRef.current;
        const wasSearchRoute = previousPath === "/TableSearch" || previousPath.startsWith("/TableDetails");

        if (!isSearchRoute) {
            form.setValues({ ...SEARCH_FORM_INITIAL_VALUES });
            form.clearErrors();
            setAdvancedOpen(false);
            if (wasSearchRoute) {
                dispatch(clearLastSearchCriteria());
            }
        }

        previousPathRef.current = currentPath;
        isSubmittingRef.current = false;
    }, [url.pathname, dispatch]);

    useEffect(() => {
        localeRef.current = locale;
    }, [locale]);

    const handlePronesiaChange = useCallback(
        (value) => {
            form.setFieldValue("pronesia", value);
            if (value !== "2") form.setFieldValue("perqindjaPronaritHuaj", "");
            if (value !== "2" && value !== "3" && value !== "4") form.setFieldValue("shtetiIdPronarit", "");
            if (value !== "1") form.setFieldValue("komunaIdPronarit", "");
            if (value !== "5") form.setFieldValue("kodiInstitucionit", "");
        },
        [form]
    );

    const resetSearchForm = useCallback(() => {
        form.setValues({ ...SEARCH_FORM_INITIAL_VALUES });
        form.clearErrors();
        setAdvancedOpen(false);
        dispatch(clearLastSearchCriteria());
        isSubmittingRef.current = false;
        setIsLoading(false);
        if (isTurnstileEnabled && window.turnstile && turnstileWidgetIdRef.current !== null) {
            try {
                window.turnstile.reset(turnstileWidgetIdRef.current);
                // eslint-disable-next-line no-empty
            } catch (e) {}
        }
    }, [form, dispatch]);

    function executeSearch(valuesInput, gjuhaId, token = "") {
        const kerkimiAvancuar = ADVANCED_VALUE_KEYS.some((key) => hasFilterValue(valuesInput[key]));
        const values = {
            NUI: valuesInput.nui || "",
            emriBiznesit: valuesInput.emriBiznesit || "",
            numriPersonal: valuesInput.numriPersonal || "",
            NrFiscal: valuesInput.nrFiscal || "",
            AktivitetiKryesor: valuesInput.aktivitetiKryesorId || "",
            Sektori: valuesInput.sektoriId || "",
            AktivitetetTjera: valuesInput.aktivitetetTjeraId || "",
            KomunaBiznesit: Number(valuesInput.komunaBiznesitId || 0),
            LlojiBiznesitID: Number(valuesInput.llojiBiznesitId || 0),
            Pronesia: Number(valuesInput.pronesia || 0),
            ShtetiIDPronarit: Number(valuesInput.shtetiIdPronarit || 0),
            KomunaIDPronarit: Number(valuesInput.komunaIdPronarit || 0),
            PerqindjaPronaritHuaj: Number(valuesInput.perqindjaPronaritHuaj || 0),
            EmriPronarit: valuesInput.emriPronarit || "",
            MbiemeriPronarit: valuesInput.mbiemriPronarit || "",
            StatusiBiznesit: Number(valuesInput.statusiBiznesitId || 0),
            NumriNjesise: valuesInput.numriNjesise || "",
            NumriNjesiveRegjistruar: valuesInput.numriNjesiveRegjistruar || "",
            NumriPuntoreve: valuesInput.numriPuntoreve || "",
            KodiInstitucionit: valuesInput.kodiInstitucionit || "",
            EmriVjeter: valuesInput.emriVjeter || "",
            Email: valuesInput.email || "",
            Telefoni: valuesInput.telefoni || "",
            Adresa: valuesInput.adresa || "",
            VitiThemelimit: Number(valuesInput.vitiThemelimit || 0),
            VitiShuarjes: Number(valuesInput.vitiShuarjes || 0),
            VitiNdryshimit: Number(valuesInput.vitiNdryshimit || 0),
            NdryshimiTipit: valuesInput.ndryshimiTipitId || "",
            KerkimiAvancuar: kerkimiAvancuar,
            Gjuha: `${gjuhaId}`,
            gjuhaId,
            token,
        };
        postData("Services/KerkoBiznesin", values)
            .then((response) => {
                dispatch(updateTable(response.data));
                history.push("/TableSearch");
            })
            .catch(() => {
                toast.error(getLabels(localeRef.current).form.networkError);
            })
            .finally(() => {
                resetSearchLoading();
            });
    }

    useEffect(() => {
        const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
        const container = turnstileContainerRef.current;
        if (!isTurnstileEnabled || !siteKey || !container) return function noop() {};
        if (turnstileWidgetIdRef.current !== null && window.turnstile) {
            window.turnstile.remove(turnstileWidgetIdRef.current);
            turnstileWidgetIdRef.current = null;
        }
        const doRender = function doRenderFn() {
            if (window.turnstile && turnstileContainerRef.current && turnstileWidgetIdRef.current === null) {
                turnstileWidgetIdRef.current = window.turnstile.render(turnstileContainerRef.current, {
                    sitekey: siteKey,
                    theme: "light",
                    size: "normal",
                    appearance: "interaction-only",
                    execution: "execute",
                    callback: function onTurnstileToken(token) {
                        const p = pendingSubmitRef.current;
                        if (!p || !token) {
                            resetSearchLoading();
                            return;
                        }
                        pendingSubmitRef.current = null;
                        executeSearch(p.values, p.gjuhaId, token);
                    },
                    "error-callback": function onTurnstileError() {
                        resetSearchLoadingStateOnly();
                        const now = Date.now();
                        if (now - lastTurnstileErrorAlertRef.current < 2000) return;
                        lastTurnstileErrorAlertRef.current = now;
                        toast.error(getLabels(localeRef.current).form.verificationFailed);
                    },
                    "expired-callback": function onTurnstileExpired() {
                        resetSearchLoadingStateOnly();
                    },
                });
            }
        };
        if (window.turnstile) {
            doRender();
        } else {
            const script = document.createElement("script");
            script.src = TURNSTILE_SCRIPT_URL;
            script.async = true;
            script.defer = true;
            script.onload = doRender;
            document.head.appendChild(script);
        }
        return function cleanup() {
            if (window.turnstile && turnstileWidgetIdRef.current !== null) {
                window.turnstile.remove(turnstileWidgetIdRef.current);
                turnstileWidgetIdRef.current = null;
            }
        };
    }, [location]);

    function handleSubmit(event) {
        event.preventDefault();

        if (isSubmittingRef.current) {
            return;
        }
        if (isLoading) {
            return;
        }

        const now = Date.now();
        if (now - lastSubmitAtRef.current < SEARCH_DEBOUNCE_MS) {
            return;
        }

        if (form.validate().hasErrors) {
            toast.error(L.form.validationError);
            return;
        }

        dispatch(
            setLastSearchCriteria({
                values: normalizeSearchFormValues(form.values),
            })
        );

        if (!isTurnstileEnabled) {
            lastSubmitAtRef.current = now;
            isSubmittingRef.current = true;
            setIsLoading(true);
            executeSearch({ ...form.values }, languageId, "");
            return;
        }
        if (!window.turnstile || turnstileWidgetIdRef.current === null) {
            toast.error(L.form.verificationLoading);
            return;
        }
        lastSubmitAtRef.current = now;
        isSubmittingRef.current = true;
        setIsLoading(true);
        pendingSubmitRef.current = { values: { ...form.values }, gjuhaId: languageId };
        window.turnstile.execute(turnstileContainerRef.current);
    }

    const ownershipSubfields = () => {
        const { pronesia } = form.values;
        if (pronesia === "1") {
            return (
                <SelectField
                    id="bsf-KomunaPronarit"
                    /* label={L.form.komunaPronarit} */
                    icon={IconMapPin}
                    placeholder={L.form.komunaPronarit}
                    data={komunatSelect}
                    value={form.values.komunaIdPronarit}
                    onChange={(v) => form.setFieldValue("komunaIdPronarit", v)}
                    searchable
                />
            );
        }
        if (pronesia === "2") {
            return (
                <React.Fragment>
                    <SelectField
                        id="bsf-PerqindjaHuaj"
                        /* label={L.form.perqindjaHuaj} */
                        icon={IconPercentage}
                        placeholder={L.form.perqindjaHuaj}
                        data={foreignPctSelect}
                        value={form.values.perqindjaPronaritHuaj}
                        onChange={(v) => form.setFieldValue("perqindjaPronaritHuaj", v)}
                    />
                    <SelectField
                        id="bsf-Shteti"
                        /* label={L.form.shteti} */
                        icon={IconFlag}
                        placeholder={L.form.shteti}
                        data={shtetetSelect}
                        value={form.values.shtetiIdPronarit}
                        onChange={(v) => form.setFieldValue("shtetiIdPronarit", v)}
                        searchable
                        itemComponent={CountryItem}
                    />
                </React.Fragment>
            );
        }
        if (pronesia === "3") {
            return (
                <SelectField
                    id="bsf-Shteti"
                    /* label={L.form.shteti} */
                    icon={IconFlag}
                    placeholder={L.form.shteti}
                    data={shtetetSelect}
                    value={form.values.shtetiIdPronarit}
                    onChange={(v) => form.setFieldValue("shtetiIdPronarit", v)}
                    searchable
                    required
                    itemComponent={CountryItem}
                />
            );
        }
        if (pronesia === "4") {
            return (
                <SelectField
                    id="bsf-Shteti"
                    /* label={L.form.shteti} */
                    icon={IconFlag}
                    placeholder={L.form.shteti}
                    data={shtetetSelect}
                    value={form.values.shtetiIdPronarit}
                    onChange={(v) => form.setFieldValue("shtetiIdPronarit", v)}
                    searchable
                    itemComponent={CountryItem}
                />
            );
        }
        if (pronesia === "5") {
            return (
                <SelectField
                    id="bsf-Institucioni"
                    /* label={L.form.institucioni} */
                    icon={IconBuildingBank}
                    placeholder={L.form.institucioniPlaceholder}
                    data={institucionetSelect}
                    value={form.values.kodiInstitucionit}
                    onChange={(v) => form.setFieldValue("kodiInstitucionit", v)}
                    searchable
                />
            );
        }
        return null;
    };

    return (
        <div className={`search-slide-section ${location}-slideBox`}>
            <div className="tw-bg-paper tw-border tw-border-solid tw-border-line tw-shadow-card tw-rounded-brand-lg tw-py-4 tw-px-6 sm:tw-py-6 sm:tw-px-9 tw-font-inter tw-box-border tw-w-full">
                <form onSubmit={handleSubmit} noValidate>
                    <div className="tw-flex tw-items-start tw-justify-between tw-gap-4 tw-mb-4">
                        <div className="tw-flex tw-items-center tw-gap-3">
                            <div
                                className="tw-inline-flex tw-items-center tw-justify-center tw-w-11 tw-h-11 tw-rounded-brand-lg tw-bg-navy-a10 tw-text-navy tw-flex-shrink-0"
                                aria-hidden
                            >
                                <IconBuildingSkyscraper size={24} stroke={2} />
                            </div>
                            <div>
                                <h2 className="tw-m-0 tw-text-xl tw-font-bold tw-leading-tight tw-text-ink tw-font-inter">
                                    {L.form.title}
                                </h2>
                                <p className="tw-m-0 tw-text-xs tw-uppercase tw-font-semibold tw-tracking-overline tw-text-muted tw-leading-relaxed">
                                    {L.form.subtitle}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={resetSearchForm}
                            aria-label={L.form.resetTooltip}
                            title={L.form.resetTooltip}
                            className="tw-inline-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-p-0 tw-rounded-full tw-border tw-border-solid tw-border-line tw-bg-transparent tw-text-muted hover:tw-text-navy hover:tw-border-navy hover:tw-bg-navy-a06 tw-cursor-pointer tw-flex-shrink-0 tw-transition-colors"
                        >
                            <IconRotate size={18} stroke={2} />
                        </button>
                    </div>

                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-5 tw-gap-x-4 tw-gap-y-1">
                        <TextField
                            id="bsf-EmriBiznesit"
                            /* label={L.form.emriBiznesit} */
                            icon={IconBuilding}
                            placeholder={L.form.emriBiznesitPlaceholder}
                            inputProps={form.getInputProps("emriBiznesit")}
                        />
                        <TextField
                            id="bsf-NUI"
                            /* label={L.form.nui} */
                            icon={IconHash}
                            placeholder={L.form.nuiPlaceholder}
                            inputProps={form.getInputProps("nui")}
                        />
                        <SelectField
                            id="bsf-KomunaBiznesit"
                            /* label={L.form.komuna} */
                            icon={IconMapPin}
                            placeholder={L.form.komuna}
                            data={komunatSelect}
                            value={form.values.komunaBiznesitId}
                            onChange={(v) => form.setFieldValue("komunaBiznesitId", v)}
                            searchable
                            error={form.errors.komunaBiznesitId}
                        />
                        <SelectField
                            id="bsf-Sektori"
                            /* label={L.form.sektori} */
                            icon={IconBriefcase}
                            placeholder={L.form.sektori}
                            data={sektoretSelect}
                            value={form.values.sektoriId}
                            onChange={(v) => form.setFieldValue("sektoriId", v)}
                            searchable
                            error={form.errors.sektoriId}
                        />
                        <SelectField
                            id="bsf-StatusiBiznesit"
                            /* label={L.form.statusi} */
                            icon={IconListCheck}
                            placeholder={L.form.statusi}
                            data={businessStatusSelect}
                            value={form.values.statusiBiznesitId}
                            onChange={(v) => form.setFieldValue("statusiBiznesitId", v)}
                            error={form.errors.statusiBiznesitId}
                        />
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-2 tw-mt-3">
                        <hr className="tw-flex-1 tw-m-0 tw-border-0 tw-border-t tw-border-solid tw-border-navy" />
                        <button
                            type="button"
                            onClick={() => setAdvancedOpen((o) => !o)}
                            aria-expanded={advancedOpen}
                            aria-controls="bsf-advanced-section"
                            className="tw-inline-flex tw-items-center tw-gap-1 tw-py-1 tw-px-2 tw-rounded-brand tw-border-0 tw-bg-transparent tw-text-navy tw-text-sm tw-font-semibold tw-cursor-pointer hover:tw-bg-navy-a06 tw-transition-colors"
                        >
                            {L.form.advancedToggle}
                            <span
                                className="tw-inline-flex tw-transition-transform"
                                style={{ transform: advancedOpen ? "rotate(180deg)" : "rotate(0deg)" }}
                                aria-hidden
                            >
                                <IconChevronDown size={18} stroke={2} />
                            </span>
                        </button>
                    </div>

                    <Collapse in={advancedOpen}>
                        <div id="bsf-advanced-section" className="tw-pt-2">
                            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-x-4 tw-gap-y-4">
                                <fieldset className="sm:tw-col-span-2 md:tw-col-span-4 tw-m-0 tw-px-3 tw-pt-1 tw-pb-2 tw-rounded-brand-md tw-border tw-border-solid tw-border-navy-a45 tw-bg-navy-a03 tw-min-w-0">
                                    <legend className="tw-px-2 tw-w-auto tw-text-navy tw-font-bold tw-text-13 tw-tracking-wide2 tw-mb-0">
                                        {L.form.teDhenatShteseLegend}
                                    </legend>
                                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-1">
                                        <SelectField
                                            id="bsf-AktivitetiKryesorAdv"
                                            /* label={L.form.aktivitetiKryesor} */
                                            icon={IconBriefcase}
                                            placeholder={L.form.aktivitetiKryesor}
                                            data={aktivitetetSelect}
                                            value={form.values.aktivitetiKryesorId}
                                            onChange={(v) => form.setFieldValue("aktivitetiKryesorId", v)}
                                            searchable
                                        />
                                        <SelectField
                                            id="bsf-AktivitetetTjera"
                                            /* label={L.form.aktivitetetTjera} */
                                            icon={IconStack2}
                                            placeholder={L.form.aktivitetetTjera}
                                            data={aktivitetetSelect}
                                            value={form.values.aktivitetetTjeraId}
                                            onChange={(v) => form.setFieldValue("aktivitetetTjeraId", v)}
                                            searchable
                                        />
                                        <SelectField
                                            id="bsf-FormaBiznesit"
                                            /* label={L.form.formaBiznesit} */
                                            icon={IconBuildingStore}
                                            placeholder={L.form.formaBiznesit}
                                            data={businessFormSelect}
                                            value={form.values.llojiBiznesitId}
                                            onChange={(v) => form.setFieldValue("llojiBiznesitId", v)}
                                        />
                                        <SelectField
                                            id="bsf-NdryshimiTipit"
                                            /* label={L.form.ndryshimiTipit} */
                                            icon={IconBriefcase}
                                            placeholder={L.form.ndryshimiTipit}
                                            data={ndryshimetTipitSelect}
                                            value={form.values.ndryshimiTipitId}
                                            onChange={(v) => form.setFieldValue("ndryshimiTipitId", v)}
                                            searchable
                                        />
                                        <TextField
                                            id="bsf-NumriFiskal"
                                            /* label={L.form.numriFiskal} */
                                            icon={IconReceipt2}
                                            placeholder={L.form.numriFiskal}
                                            inputProps={form.getInputProps("nrFiscal")}
                                        />
                                        <TextField
                                            id="bsf-EmriVjeter"
                                            /* label={L.form.emriVjeter} */
                                            icon={IconHistory}
                                            placeholder={L.form.emriVjeterPlaceholder}
                                            inputProps={form.getInputProps("emriVjeter")}
                                        />
                                        <TextField
                                            id="bsf-NumriNjesise"
                                            /* label={L.form.numriNjesise} */
                                            icon={IconHash}
                                            placeholder={L.form.numriNjesise}
                                            inputProps={form.getInputProps("numriNjesise")}
                                        />
                                        <SelectField
                                            id="bsf-NumriNjesive"
                                            /* label={L.form.numriNjesiveTeRegjistruara} */
                                            icon={IconShieldCheck}
                                            placeholder={L.form.numriNjesiveTeRegjistruara}
                                            data={unitCountSelect}
                                            value={form.values.numriNjesiveRegjistruar}
                                            onChange={(v) => form.setFieldValue("numriNjesiveRegjistruar", v)}
                                        />
                                        <SelectField
                                            id="bsf-NumriPuntoreve"
                                            /* label={L.form.numriPuntoreve} */
                                            icon={IconUsers}
                                            placeholder={L.form.numriPuntorevePlaceholder}
                                            data={puntoretSelect}
                                            value={form.values.numriPuntoreve}
                                            onChange={(v) => form.setFieldValue("numriPuntoreve", v)}
                                        />
                                    </div>
                                </fieldset>
                                <fieldset className="sm:tw-col-span-2 md:tw-col-span-4 tw-m-0 tw-px-3 tw-pt-1 tw-pb-2 tw-rounded-brand-md tw-border tw-border-solid tw-border-navy-a45 tw-bg-navy-a03 tw-min-w-0">
                                    <legend className="tw-px-2 tw-w-auto tw-text-navy tw-font-bold tw-text-13 tw-tracking-wide2 tw-mb-0">
                                        {L.form.pronariLegend}
                                    </legend>
                                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-1">
                                        <TextField
                                            id="bsf-NrPersonal"
                                            /* label={L.form.nrPersonal} */
                                            icon={IconIdBadge2}
                                            placeholder={L.form.nrPersonal}
                                            inputProps={form.getInputProps("numriPersonal")}
                                        />
                                        <TextField
                                            id="bsf-EmerPronari"
                                            /* label={L.form.emerPronari} */
                                            icon={IconUser}
                                            placeholder={L.form.emerPronari}
                                            inputProps={form.getInputProps("emriPronarit")}
                                        />
                                        <TextField
                                            id="bsf-MbiemriPronarit"
                                            /* label={L.form.mbiemriPronarit} */
                                            icon={IconUser}
                                            placeholder={L.form.mbiemriPronarit}
                                            inputProps={form.getInputProps("mbiemriPronarit")}
                                        />
                                    </div>
                                </fieldset>
                                <fieldset className="sm:tw-col-span-2 md:tw-col-span-4 tw-m-0 tw-px-3 tw-pt-1 tw-pb-2 tw-rounded-brand-md tw-border tw-border-solid tw-border-navy-a45 tw-bg-navy-a03 tw-min-w-0">
                                    <legend className="tw-px-2 tw-w-auto tw-text-navy tw-font-bold tw-text-13 tw-tracking-wide2 tw-mb-0">
                                        {L.form.vitetLegend}
                                    </legend>
                                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-1">
                                        <SelectField
                                            id="bsf-VitiThemelimit"
                                            /* label={L.form.vitiThemelimit} */
                                            icon={IconCalendar}
                                            placeholder={L.form.vitiThemelimit}
                                            data={yearOptions}
                                            value={form.values.vitiThemelimit}
                                            onChange={(v) => form.setFieldValue("vitiThemelimit", v)}
                                            searchable
                                        />
                                        <SelectField
                                            id="bsf-VitiShuarjes"
                                            /* label={L.form.vitiShuarjes} */
                                            icon={IconCalendar}
                                            placeholder={L.form.vitiShuarjes}
                                            data={yearOptions}
                                            value={form.values.vitiShuarjes}
                                            onChange={(v) => form.setFieldValue("vitiShuarjes", v)}
                                            searchable
                                        />
                                        <SelectField
                                            id="bsf-VitiNdryshimit"
                                            /* label={L.form.vitiNdryshimit} */
                                            icon={IconCalendar}
                                            placeholder={L.form.vitiNdryshimit}
                                            data={yearOptions}
                                            value={form.values.vitiNdryshimit}
                                            onChange={(v) => form.setFieldValue("vitiNdryshimit", v)}
                                            searchable
                                        />
                                    </div>
                                </fieldset>
                                <fieldset className="sm:tw-col-span-2 md:tw-col-span-4 tw-m-0 tw-px-3 tw-pt-1 tw-pb-2 tw-rounded-brand-md tw-border tw-border-solid tw-border-navy-a45 tw-bg-navy-a03 tw-min-w-0">
                                    <legend className="tw-px-2 tw-w-auto tw-text-navy tw-font-bold tw-text-13 tw-tracking-wide2 tw-mb-0">
                                        {L.form.kontaktiLegend}
                                    </legend>
                                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-1">
                                        <TextField
                                            id="bsf-Email"
                                            /* label={L.form.email} */
                                            icon={IconMail}
                                            placeholder={L.form.emailPlaceholder}
                                            inputProps={form.getInputProps("email")}
                                        />
                                        <TextField
                                            id="bsf-Telefoni"
                                            /* label={L.form.telefoni} */
                                            icon={IconPhone}
                                            placeholder={L.form.telefoniPlaceholder}
                                            inputProps={form.getInputProps("telefoni")}
                                        />
                                        <TextField
                                            id="bsf-Adresa"
                                            /* label={L.form.adresa} */
                                            icon={IconMapPin}
                                            placeholder={L.form.adresaPlaceholder}
                                            inputProps={form.getInputProps("adresa")}
                                        />
                                    </div>
                                </fieldset>
                                <fieldset className="sm:tw-col-span-2 md:tw-col-span-4 tw-m-0 tw-px-3 tw-pt-1 tw-pb-2 tw-rounded-brand-md tw-border tw-border-solid tw-border-navy-a45 tw-bg-navy-a03 tw-min-w-0">
                                    <legend className="tw-px-2 tw-w-auto tw-text-navy tw-font-bold tw-text-13 tw-tracking-wide2 tw-mb-0">
                                        {L.form.pronesiaLegend}
                                    </legend>
                                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-x-4 tw-gap-y-1">
                                        <SelectField
                                            id="bsf-Pronesia"
                                            /* label={L.form.pronesia} */
                                            icon={IconUserCircle}
                                            placeholder={L.form.pronesia}
                                            data={ownershipSelect}
                                            value={form.values.pronesia}
                                            onChange={handlePronesiaChange}
                                        />
                                        {ownershipSubfields()}
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </Collapse>

                    {isTurnstileEnabled && <div ref={turnstileContainerRef} className="turnstile-search" />}
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="tw-mt-4 tw-w-full tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-py-2 tw-px-5 tw-box-border tw-rounded-brand tw-border-0 tw-bg-navy hover:tw-bg-navy-dark tw-text-white tw-text-15 tw-font-bold tw-tracking-wide4 tw-cursor-pointer disabled:tw-opacity-60 disabled:tw-cursor-not-allowed tw-transition-colors"
                    >
                        {isLoading ? (
                            <IconLoader2 size={18} stroke={2.5} className="tw-animate-spin" />
                        ) : (
                            <IconSearch size={18} stroke={2.5} />
                        )}
                        {L.form.submit}
                    </button>
                </form>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(SearchSlide);
